import React from 'react';
import * as S from './style';

const RadioButton = (props) => {
  return <S.Input {...props} type="radio" />;
};

export default RadioButton;
